import React from 'react'

export const NotFound: React.FC = () => {
  return (
    <div>
      <h2>Página não encontrada</h2>
    </div>
  )
}
